import React from 'react';
import PropTypes from 'prop-types';

import CommunicationsFilter from './CommunicationsFilter';
import PoliciesQuotesFilter from './PoliciesQuotesFilter';
import style from './PanelHeader.module.css';

const PanelHeader = React.memo(
  ({
    icon,
    title,
    communications = false,
    policiesQuotes = false,
    filterState = {
      policies: false,
      quotes: false
    }
  }) => {
    return (
      <div className={style.main}>
        <img src={icon} alt={title} className={style.icon} />
        <span className={style.title}>{title}</span>
        {communications && <CommunicationsFilter />}
        {policiesQuotes && <PoliciesQuotesFilter filterState={filterState} />}
      </div>
    );
  },
);

PanelHeader.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  communications: PropTypes.bool,
  policiesQuotes: PropTypes.bool,
  filterState: PropTypes.shape({
    policies: PropTypes.bool.isRequired,
    quotes: PropTypes.bool.isRequired,
  }),
};

export default PanelHeader;
